import { jsx as a } from "@emotion/react/jsx-runtime";
import { useRef as c, useState as b, useMemo as d, createContext as S, useContext as f } from "react";
const n = S(void 0), v = () => {
  const e = f(n);
  if (!e)
    throw new Error("useSidebarContext must be used within a SidebarProvider");
  return e;
}, w = ({
  extended: e,
  setExtended: o,
  children: i
}) => {
  const r = c(null), [t, s] = b(!1), u = d(() => ({
    sidebarRef: r,
    extended: e,
    setExtended: o,
    showMoreMenu: t,
    setShowMoreMenu: s
  }), [r, e, o, t, s]);
  return /* @__PURE__ */ a(n.Provider, { value: u, children: i });
};
export {
  w as SidebarProvider,
  v as useSidebarContext
};
